import { defineStore } from 'pinia'
import { fetchItems, createItem, activateVoucher } from '@/api/replenishments'
import { IVoucherData } from '@/interfaces/replenishments'
import useCrudStore from '@/hooks/useCrudStore'

export const useReplenishmentsStore = defineStore('replenishment', () => {
  const {
    filter,
    total,
    currentPage,
    currentItems,
    listLoading,
    itemsLoading,
    FetchItems,
    SaveItem,
    SetFilters,
    SetCurrentPage,
    SetLimit
  } = useCrudStore({
    fetchItems,
    createItem,
    updateItem: createItem
  })

  const ActivateVoucher = async (payload: IVoucherData) => {
    itemsLoading.value[payload.id] = true
    try {
      const response = await activateVoucher(payload)
      itemsLoading.value = {}
      return response
    } catch {
      itemsLoading.value = {}
    }
  }

  return {
    // State
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,
    itemsLoading,

    // Actions
    SetFilters,
    FetchItems,
    SetCurrentPage,
    SetLimit,
    SaveItem,
    ActivateVoucher
  }
})
